<template>

<div>

  <app-header />

  <div class="container">


		<nav aria-label="breadcrumb">
			<ol class="breadcrumb">
				<li class="breadcrumb-item"><router-link :to="'/project/'+project.id">{{ project.name }}</router-link></li>
				<li class="breadcrumb-item active" aria-current="page">{{_lang('Edit')}}</li>
			</ol>
		</nav>

      <form method="post" @submit.prevent="onSubmit">

      <div class="form-group">
        <label>{{_lang('Name')}}</label>
        <input v-model="project.name" type="text" class="form-control" >
      </div>


      <fieldset>
      <div class="form-group">
        <label>{{_lang('Fonts')}}</label>
        <ul class="list-fonts" v-if="project.meta && project.meta.fonts">
            <li v-for="font in project.meta.fonts">
                <strong v-if="project.meta.defaultFont == font.family">{{_lang('Default')}}:</strong> {{ font.family }} <span class="badge badge-dark badge-pill mr-2">{{font.variants.join('/')}}</span>
                <button class="btn btn-light btn-sm mr-2" v-if="project.meta.defaultFont != font.family" @click.prevent="setDefaultFont(font)">{{_lang('set default')}}</button>
                <button class="btn btn-light btn-sm text-danger" @click.prevent="removeFont(font)"><svg class="icosvg" viewBox="0 0 24 24"><path fill="currentColor" d="M19,4H15.5L14.5,3H9.5L8.5,4H5V6H19M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19Z" /></svg></button>
              </li>
        </ul>
        <div class="form-group">
          <label>{{_lang('Add font')}}</label>
          <font-select @add="addFont" :placeholder="_lang('search')" />
		  <custom-font-select @add="addFont" />
        </div>

      </div>
      </fieldset>


      <div class="form-group">
        <label>{{_lang('Header code')}}</label>
        <textarea class="form-control" v-model="project.meta.header">
        </textarea>
      </div>

      <div class="form-group">
        <label>{{_lang('Footer code')}}</label>
        <textarea class="form-control" v-model="project.meta.footer">
        </textarea>
      </div>

      <div class="form-group">
        <label>{{_lang('Facebook Conversions API')}}</label>
				<div>
					<label class="checkbox">
						<input type="checkbox" v-model="conversionsApiEnabled"> Enable
					</label>
				</div>
				<div v-if="conversionsApiEnabled">
      		<div class="form-group">
        		<label>Conversions API - Access Token</label>
						<input type="text" class="form-control" required v-model="project.meta.conversionApiAccessToken">
					</div>
      		<div class="form-group">
        		<label>Conversions API - Pixel ID</label>
						<input type="text" class="form-control" required v-model="project.meta.conversionApiPixelId">
					</div>
				</div>

      </div>


<!-- image upload - tiny inline preview -->
<div class="form-group">
  <label>Favicon</label>
  <div class="d-flex">
    <div class="custom-file">
      <input type="file" class="custom-file-input" @change="onFileChange($event,project.meta,'favicon')">
      <label class="custom-file-label">Upload</label>
    </div>
    <div class="flex-shrink-0">
      <img v-if="project.meta && project.meta.favicon" :src="project.meta.favicon" class="img-thumbnail" style="max-height:38px">
    </div>
    <button v-if="project.meta.favicon" class="close p-2" @click="project.meta.favicon=''"><span>&times;</span></button>
  </div>
</div>


    <button type="submit" :disabled="isLoading" class="btn btn-primary">{{_lang('Save')}} <ico v-if="isLoading" ico="loading" style="display:inline-block" /></button>
    <router-link class="btn btn-light" :to="'/project/'+project.id">{{_lang('Cancel')}}</router-link>
    <span class="btn btn-danger float-right" @click="onDelete">
      <svg class="icosvg" viewBox="0 0 24 24">
        <path fill="currentColor" d="M19,4H15.5L14.5,3H9.5L8.5,4H5V6H19M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19Z" />
      </svg>
    </span>


</form>
</div>
</div>

</template>
<script>

import componentFunctions from '../mixin.components.js'
import axios from 'axios';

import appHeader from '../components/appHeader.vue'
import FontSelect from '../components/FontSelect.vue'
import CustomFontSelect from '../components/CustomFontSelect.vue'

import Ico from '../components/Ico'


export default {
  name: 'project-form',
  components:{
    appHeader,
    FontSelect,
	CustomFontSelect,
    Ico,
  },
  mixins:[componentFunctions],
  props:['id'],
  data() {
    return {
    	isLoading:false,
			conversionsApiEnabled:false,
      project:{
        id:'',
        name:'',
        meta:{
          fonts:[],
          defaultFont:'',
          header:'',
          footer:'',
          favicon:'',
        },
        thumbnail:'',
      },
    }
  },
  methods:{
    getProject(id){
      axios({
        url: '/api/projects/'+id,
      }).then((res) => {
        if(!res.data.meta || !res.data.meta.fonts){
            res.data.meta = {
              fonts:[
                {
                  family:'Open Sans',
                  variants:['regular','italic','700','700italic'],
                }
              ],
              defaultFont:'Open Sans'
            };
        }

        this.project = res.data;

				this.conversionsApiEnabled = !!res.data.meta.conversionApiAccessToken;

      });
    },

    onSubmit(){

    		this.isLoading = true;
        var endpoint = '/api/projects';
        if(this.id) endpoint  = endpoint +'/'+this.id

        axios({
            method: 'post',
            url: endpoint,
            data: this.project
        }).then((res) => {
            this.$router.push('/project/'+res.data.id);
	      }).catch(err=>{
        	this.isLoading = false;
        	alert(JSON.stringify(err));
        });

    },
    onDelete(){
        if(!confirm(this._lang("Are you sure?"))) return;

        axios({
            method: 'delete',
            url: '/api/projects/'+this.id,
        }).then((res) => {

            this.$router.push('/');

      });

    },


    setDefaultFont(font){
      this.project.meta.defaultFont = font.family;
      var fonts = this.project.meta.fonts;
      var index = fonts.indexOf(font);
      var defaultFont = fonts.splice(index,1)[0];
      this.project.meta.fonts = [defaultFont,...fonts];
    },
    addFont(font){
      var exists = this.project.meta.fonts.find(item=>item.family == font.family);
      console.log('exists',exists);
      if(exists){
        var index = this.project.meta.fonts.indexOf(exists);
        this.project.meta.fonts.splice(index,1);
      }
      this.project.meta.fonts.push(font);
      if(exists && this.project.meta.defaultFont==font.family){
        this.setDefaultFont(font);
        return;
      }
      if(this.project.meta.fonts.length==1){
        this.setDefaultFont(this.project.meta.fonts[0]);
      }
    },
    removeFont(font){
      var index = this.project.meta.fonts.indexOf(font);

      if(index!=undefined)
        this.project.meta.fonts.splice(index,1);
        if(font.family==this.project.meta.defaultFont && this.project.meta.fonts.length>0){
          this.setDefaultFont(this.project.meta.fonts[0]);
        }
    },




  },
  mounted(){
      this.getProject(this.id);
  }

}



</script>

<style scoped>

.list-fonts { list-style-position: inside; padding:0}
.list-fonts li { }
</style>
